import { i18n } from '@lingui/core';

export interface BinderSuppliersPageParams extends Record<string, string | undefined> {
  projectId: string;
}

export const PROJECT_PARAM_IDENTIFIER = ':projectId';

export const ROUTE_PATH = `/projects/${PROJECT_PARAM_IDENTIFIER}/binder-suppliers`;
export const TITLE = i18n._('Binder Suppliers');
